export default "/_next/static/chunks/fonts/Entypo-fc6169344c041cffcdae6145f905af4f.ttf";